module.exports = __webpack_public_path__ + "static/media/panificio profilo.e9b4712d.svg";